// @flow

import type { ActivesState as State } from '../types';
import type { State as ConfigState } from '../../types';
import type { State as PdbState } from '../../../pdb/types';
import type { OrderFormState } from '../../../orderForm/types';

type GlobalState = {
  configuration: ConfigState,
  pdb: PdbState,
  orderForm: OrderFormState,
};

export const getReducer = (state: GlobalState): State => state.configuration.actives;

export default null;
